<template>
    <div class="response-holder">
        <div v-for="(dateResponse, index) in response"
            :key="index"
            class="date-response">
            <div class="date">
                {{ dateResponse.time }}
            </div>
            <div class="response" v-if="dateResponse.response">
                <span :class="{active : dateResponse.response.state === 'complete'}">
                    <i class="el-icon-check"></i>
                    Completed
                </span>
                <span :class="{active: dateResponse.response.state === 'n/a'}">
                    <i class="el-icon-close"></i>
                    Does Not Apply
                </span>
            </div>
            <span v-if="!dateResponse.response.hasOwnProperty('state') && dateResponse.isHistory" class="no-answer">
                Not Answered
            </span>
        </div>
    </div>
</template>

<script>
import { isEmptyObject } from '@/module/util'

export default {
    name: 'checklist-analysis-response',
    
    props: {
        response: {
            type: Array,
            required: true
        }
    },

    methods: {
        isEmptyObject
    }
}
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";

.response-holder{
    padding-bottom: 20px;
}

.date-response {
    display: flex;
    margin-top: 10px;
    font-size: 12px;
    align-items: center;
    height: 30px;
    .date {
        padding-left: 15px;
        width: 60px;
        color: $checklist-color;
        font-weight: bold;
    }
    .response {
        span {
            text-align: center;
            display: inline-block;
            border: 1px solid #cccccc;
            margin-left: 8px;
            background-color: #f8f8f8;
            height: 100%;
            padding: 8px;
            font-size: 12px;
            border-radius: 15px;
            color: #666666;
            i {
                vertical-align: bottom;
            }
        }
        span.active {
            color: $checklist-color;
            border: 1px solid $checklist-color;
            font-weight: 600;
            background-color: lighten($checklist-color, 45%)
        }
        span.complete {
            color: $success-color;
            border: 1px solid $success-color;
            font-weight: 600;
            background-color: lighten($success-color, 45%)
        }
    }
    .no-answer {
        color: $danger-color;
        background-color: #fff2f2;
        font-size: 13px;
        display: inline-block;
        padding: 5px 6px;
        font-weight: 500;
        margin-left: 10px;
    }
}
</style>
